// extracted by mini-css-extract-plugin
export var legendIndicator = "_c6-1";
export var legendRight = "_c6-0";